import type { PayloadAction } from '@reduxjs/toolkit'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import magnifyApi from '@/http/magnify'
import moment from 'moment'

const initialState: {
  storage: any,
  showStorageTab: Boolean,
} = {
  storage: {},
  showStorageTab: false
}

function createExtraActions() {
  return {
    fetchStorage: createAsyncThunk(
      `/get-storage`,
      async (_, thunkAPI) => {
        return;
        const dispatch = thunkAPI.dispatch
        const response: any = await magnifyApi.get_storage_details({
          startDate: moment().startOf('month').toISOString(),
          endDate: moment().endOf('month').toISOString(),
          entityId: localStorage.getItem('entityId')
        })
        if (response?.status) {
          const storage = {
            data: response?.data?.dataFromStorageAPI?.data[0],
            translation: response?.data?.dataFromTranslationAPI?.data[0],
            transcription: response?.data?.dataFromAutoSubtitleAPI?.data[0]
          }
          dispatch(storageActions.setStorage(storage))
        }
      },
    ),
  }
}

const extraActions = createExtraActions()

export const storageSlice = createSlice({
  name: 'storage',
  initialState,
  reducers: {
    setStorage(state, { payload }: PayloadAction<any>) {
      state.storage = payload
    },
    showStorageTab(state, { payload }: PayloadAction<any>) {
      state.showStorageTab = payload
    },
  },
})

export const storageActions = { ...storageSlice.actions, ...extraActions }

export default storageSlice.reducer
